import React from 'react';
import { useMousePosition } from '../../hooks/useMousePosition';

export const Cursor = () => {
  const { x, y, isTouch } = useMousePosition();

  if (isTouch) return null;

  return (
    <div
      className="fixed w-11 h-11 rounded-full pointer-events-none z-[9998] mix-blend-difference"
      style={{
        left: x,
        top: y,
        transform: 'translate(-50%, -50%)',
        background: 'radial-gradient(circle, var(--accent) 0%, transparent 70%)',
        opacity: 0.6,
        transition: 'transform 0.1s ease-out',
      }}
      aria-hidden="true"
    />
  );
};